import {LIST_TYPES, SEARCH_TYPES} from '../constants';
import {SavedSearchType} from '../typedef';

type TypeSpecificData = {
    advancedSearchType?: string,
    listType?: string,
    savedItemType?: string,
};

export const getSearchTypeSpecificData = (
    rawCode: string | undefined,
    savedSearchType: SavedSearchType,
    getTypeDescription: (code: string | undefined) => string,
): TypeSpecificData => {
    if (savedSearchType === 'SEARCH') {
        return {
            advancedSearchType: rawCode || undefined,
            savedItemType: (rawCode ? SEARCH_TYPES[rawCode] : undefined) || getTypeDescription(rawCode),
        };
    } else {
        return {
            listType: rawCode || undefined,
            savedItemType: (rawCode ? LIST_TYPES[rawCode] : undefined) || getTypeDescription(rawCode),
        };
    }
};
